const sizeConfigs = {
  sidebar: {
    collapsedWidth: {
      width: '85px'
    },
    unCollapsedWidth: {
      width: '250px'
    }
  }
};

export default sizeConfigs;